import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import ButtonApp from 'Shared/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DialogCmp from 'Shared/Dialog';
import DEFAULT_PRODUCT from 'Images/default_product.png';

const Title = ({ reference, bId }) => (
  <>
    <Typography sx={{ fontWeight: 600, color: '#75808E', display: 'contents' }}>{reference}</Typography>
    {' - '}
    <Typography sx={{ fontWeight: 600, color: '#027BC6', display: 'contents' }}>{bId}</Typography>
  </>
);
export const SelectedProduct = ({ product }) => (
  <Box sx={{ display: 'flex' }}>
    <img
            // eslint-disable-next-line no-return-assign
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = DEFAULT_PRODUCT;
      }}
        // className={classes.media}
      src={`https://media.copima.ma/products/${product?.img}`}
      alt="--"
      style={{ height: 100 }}
    />
    <Box sx={{
      ml: 1.5, display: 'flex', flexDirection: 'column', justifyContent: 'center',
    }}
    >
      <Title reference={product.reference} bId={product.bId} />
      <Typography sx={{ fontWeight: 600, color: '#38485C' }}>{product.des}</Typography>
    </Box>
  </Box>
);

const Stocks = ({ product }) => {
  const [open, setOpen] = useState(false);
  if (!product) {
    return null;
  }
  const {
    sB = 0, sD = 0, stockAinSebaa = 0, stockCfcim = 0, stockCfcimProd = 0,
  } = product;
  if (!open) {
    return (<ButtonApp onClick={() => setOpen((p) => !p)} label="Voir Le Stock" startIcon={<VisibilityIcon />} />);
  }
  const stocks = [
    { id: 1, depo: 'BOUSKOURA', stock: sB },
    { id: 2, depo: 'CFCIM', stock: stockCfcim },
    { id: 3, depo: 'DERB OMAR', stock: sD },
    { id: 4, depo: 'AIN SEBAA', stock: stockAinSebaa },
    { id: 5, depo: 'CFCIM PRO', stock: stockCfcimProd },
    { id: 'total', depo: 'TOTAL', stock: sD + sB + stockAinSebaa + stockCfcim + stockCfcimProd },
  ];
  return (
    <DialogCmp
      title={<Title reference={product.reference} bId={product.bId} />}
      subTitle={<Typography sx={{ fontWeight: 600, color: '#38485C' }}>{product.des}</Typography>}
      endIcon={false}
      fullWidth={false}
      open
      handleClose={() => setOpen(false)}
      styleOk={{ display: 'none' }}
      styleKo={{ display: 'none' }}
    >
      <Box sx={{
        background: 'rgba(56, 72, 92, 0.11)', display: 'flex', minWidth: 600, p: 1, borderRadius: 1.5,
      }}
      >
        <Typography sx={{ fontWeight: 600, color: '#707070', width: '100%' }}>DÉPÔT</Typography>
        <Typography sx={{ fontWeight: 600, color: '#707070', width: '100%' }}>STOCK RÉEL</Typography>
      </Box>
      <Box sx={{ border: '1px solid #E3E3E3', borderRadius: 1.5, mt: 1 }}>
        {stocks.map((st) => (
          <Box key={st.id} sx={{ display: 'flex', borderBottom: st.id !== 'total' && '1px solid #E3E3E3', p: 1 }}>
            <Typography sx={{ fontWeight: 600, color: st.id === 'total' ? '#007BC6' : '#38485C', width: '100%' }}>{st.depo}</Typography>
            <Typography sx={{ fontWeight: 600, color: st.id === 'total' ? '#007BC6' : '#38485C', width: '100%' }}>{st.stock}</Typography>
          </Box>
        ))}
      </Box>
    </DialogCmp>
  );
};

export default Stocks;
